export default __webpack_public_path__ + "static/media/CardDelayTime.bc9a83da.svg";